import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Rx';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { Person } from 'app/shared/models/person.model';

/**
 * Service for person header related calls.
 */
@Injectable()
export class PersonHeaderService {
    private personDetails: Subject<Person>;

    constructor(
        private requestService: ObservableRequestService,
        private cookieService: CookieService) {
        this.personDetails = new Subject<Person>();
    }

    setPersonDetails(personDetails: Person): void {
        this.personDetails.next(personDetails);
    }

    onPersonDetailsEvent(): Observable<any> {
        return this.personDetails.asObservable();
    }

    getPerson(personId: Number): Observable<any> {
        const userId = this.cookieService.get(ConstantsService.COOKIE_LOGIN_USER_NAME);
        return this.requestService
            .getRequest(ConstantsService.PERSON_DETAILS + '/' + personId + '/' + userId);
    };

    updatePerson(body: Object): Observable<any> {
        return this.requestService.putRequest(
            ConstantsService.UPDATE_PERSON,
            JSON.stringify(body),
            this.requestService.getJSONContentType());
    };

    addComment(body: Object): Observable<any> {
        return this.requestService.postRequest(
            ConstantsService.TASK_COMMENT_ENDPOINT,
            JSON.stringify(body),
            this.requestService.getJSONContentType());
    };
}



// WEBPACK FOOTER //
// ./src/app/person/header/person-header.service.ts